import { ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ScheduledSectionTile } from '../../../views/course_scheduler/components/scheduled_section_tile/scheduled_section_tile_component';

angular.module('capability-ng-scheduler').component('swapPreviewSectionTile', {
  templateUrl: 'capability-ng-scheduler/src/swap/components/swap_preview_section_tile/swap_preview_section_tile.html',
  controller: ScheduledSectionTile,
  bindings: {
    section: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/components/swap_preview_section_tile/swap_preview_section_tile.ts